import React from "react";
import {
  TextField,
  Button,
  FormControlLabel,
  Checkbox,
  Box,
  CircularProgress,
} from "@mui/material";

const NewCardForm = ({ 
    cardholderName, setCardholderName, cardholderNameValid,
    cardNumber, setCardNumber, cardNumberValid,
    cvc, setCvc, cvcValid,
    expiry, setExpiry, expiryValid,
    zipCode, setZipCode, zipCodeValid,
    saveCard, setSaveCard,
    makeDefault, setMakeDefault,
    handleCardholderNameChange, handleCardNumberChange,
    handleCvcChange, handleExpiryChange, handleZipCodeChange,
    onAddCard, isCreatingCard
  }) => {
    return (
      <Box sx={{ mt: 2 }}>
        <TextField
          fullWidth
          label="Cardholder Name"
          margin="normal"
          value={cardholderName}
          sx={{
            padding: "0px",
            maxHeight: "40%",
            marginTop: "4px",
            marginBottom: "8px",
          }}
          onChange={handleCardholderNameChange}
          error={!cardholderNameValid && cardholderName.length > 0}
          helperText={(!cardholderNameValid && cardholderName.length > 0) ? "Please enter a valid name" : ""}
        />
        <TextField
          fullWidth
          label="Card Number"
          margin="normal"
          value={cardNumber}
          sx={{
            padding: "0px",
            maxHeight: "40%",
            marginTop: "4px",
            marginBottom: "8px",
          }}
          onChange={handleCardNumberChange}
          error={!cardNumberValid && cardNumber.length > 0}
          helperText={(!cardNumberValid && cardNumber.length > 0) ? "Card number must be 12-16 digits" : ""}
          inputProps={{ maxLength: 16 }}
        />
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            gap: 1,
            width: "100%"
          }}
        >
        <TextField
          label="CVC"
          margin="normal"
          value={cvc}
          sx={{
            padding: "0px",
            maxHeight: "40%",
            marginTop: "4px",
            marginBottom: "8px",
            maxWidth: "30%"
          }}
          onChange={handleCvcChange}
          error={!cvcValid && cvc?.length > 0}
          helperText={(!cvcValid && cvc?.length > 0) ? "CVC must be 3-4 digits" : ""}
          inputProps={{ maxLength: 4 }}
        />
        <TextField
          label="Expiry date"
          margin="normal"
          value={expiry}
          sx={{
            padding: "0px",
            maxHeight: "40%",
            marginTop: "4px",
            marginBottom: "8px",
            maxWidth: "70%"
          }}
          onChange={handleExpiryChange}
          placeholder="MM/YY"
          error={!expiryValid && expiry?.length > 0}
          helperText={(!expiryValid && expiry?.length > 0) ? "Invalid expiry date" : ""}
          inputProps={{ maxLength: 5 }}
        />
        </Box>
        <TextField
          fullWidth
          label="Zip Code"
          margin="normal"
          value={zipCode}
          sx={{
            padding: "0px",
            maxHeight: "40%",
            marginTop: "4px",
            marginBottom: "8px",
          }}
          onChange={handleZipCodeChange}
          error={!zipCodeValid && zipCode?.length > 0}
          helperText={(!zipCodeValid && zipCode?.length > 0) ? "Please enter a valid 5-digit zip code" : ""}
          inputProps={{ maxLength: 5 }}
        />
        <Box sx={{ mt: 1 }}>
          <FormControlLabel
            control={
              <Checkbox
                checked={makeDefault}
                onChange={(e) => setMakeDefault(e.target.checked)}
              />
            }
            label="Make this my default payment method"
          />
        </Box>
        <Button
          variant="contained"
          color="primary"
          fullWidth
          onClick={onAddCard}
          disabled={isCreatingCard}
          sx={{ mt: 2 }}
        >
          {isCreatingCard ? <CircularProgress size={24} /> : 'Add Card'}
        </Button>
      </Box>
    );
  };

  
export default NewCardForm;